<script setup>
/**
 * 空白布局：不带侧栏与顶栏。
 *
 * 给运维诊断这类页面用。它们要在后端连不上时也能打开，
 * 而侧栏和顶栏都依赖后端数据（状态徽章、环境标签、连接指示），
 * 挂在那套布局下反而会被拖累。
 */
</script>

<template>
  <div class="blank">
    <slot />
  </div>
</template>

<style scoped>
.blank {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--bg);
}
</style>
